import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import he from "he";
import { assetUrl, bpVars, ensureThemeJsonArray, getStoredUser } from "../../functions/themeAssets";
import { Loader } from "../bigpicture/components";
import "../styles/bp-rules.css";

/** "Line one||Line two" shows line two highlighted under line one. */
function RuleText({ text }) {
  const decoded = he.decode(String(text || "")).trim();
  if (decoded.includes("||")) {
    const [first, ...rest] = decoded.split("||");
    return (
      <>
        {first.trim()}
        <br />
        <span className="rule-line-emphasis">{rest.join("||").trim()}</span>
      </>
    );
  }
  return decoded;
}

/** "How to Play" — the rules the admin set for the theme (rules.php). */
export default function Rules() {
  const navigate = useNavigate();
  const { status, data: themeData } = useSelector((state) => state.theme);
  const user = getStoredUser();

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    } else if (Number(user.gameover ?? 0) > 0) {
      Swal.fire({
        title: "Already Played",
        text: "You have already played this game.",
        icon: "info",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.href = user.backButtonRedirect || process.env.REACT_APP_BASE_URL || "/";
      });
    }
  }, [user, navigate]);

  if (!user) return null;
  if (!themeData || status === "loading") return <Loader />;

  const rules = ensureThemeJsonArray(themeData.rules).filter((r) => String(r).trim() !== "");

  return (
    <div className="bp-rules" style={bpVars(themeData)}>
      <div className="rules-wrap">
        {themeData.logo && (
          <div className="rules-logo-wrap">
            <img src={assetUrl(themeData.logo)} alt="" className="rules-logo" />
          </div>
        )}

        <header className="rules-heading">
          <div className="rules-heading-line">
            <h1 className="rules-heading-word">How</h1>
            <span className="rules-heading-badge">to</span>
            <h1 className="rules-heading-word">Play</h1>
          </div>
          <div className="rules-heading-underline" aria-hidden="true" />
        </header>

        <ul className="rules-list">
          {rules.map((rule, i) => (
            <li className="rule-card" key={i}>
              <p className="rule-card-text">
                <RuleText text={rule} />
              </p>
            </li>
          ))}
        </ul>

        <div className="rules-submit-wrap">
          <Link className="rules-submit-btn" to="/think-fast">
            NEXT
          </Link>
        </div>
      </div>
    </div>
  );
}
